import { defineStore } from 'pinia'
import { getBriefByIdApi, getActionByIdApi } from '@/service/api/script'
export const scriptStore = defineStore('scriptStore', {
  state: () => {
    return {
      openDrawer: false,
      openEditLog: false,
      openTestWorkflow: false,
      addWorkFlow: false,
      shareWorkflow: false,
      autoRunning: false,
      autoRunningInfo: {},
      showTips: false,
      showTipsInfo: {},
      scriptInfo: {},
      hotListData: [],
      selectTag: null,
      tagList: [],
      reviewList: []
    }
  },
  getters: {
    getInputs: (state) => (val) => {
      return state.scriptInfo.elementVOList?.filter((i) => i.title?.indexOf(val) !== -1) || []
    },
    getActions: (state) => (val) => {
      return (
        state.tagList?.filter((i) => i.actionId !== 'input' && i.actionName.indexOf(val) !== -1) ||
        []
      )
    },
    getSelectIndex() {
      return this.tagList.findIndex((i) => i.actionId === this.selectTag?.actionId)
    }
  },
  //可以操作异步 和 同步提交state
  actions: {
    selectTagHandle(val, workflowInfoId) {
      // 清除错误样式
      this.tagList = this.tagList.map((i) => {
        delete i.isError
        return {
          ...i
        }
      })
      if (val.actionCode === 'input') {
        getBriefByIdApi({ workflowInfoId }).then((res) => {
          if (res.data) {
            this.selectTag = {
              ...this.tagList[0],
              actionId: 'input',
              actionCode: 'input',
              elementVOList: res.data.elementVOList
            }
          }
        })
      } else if (val.actionId?.length) {
        getActionByIdApi({
          actionId: val.actionId
        }).then((res) => {
          if (res.data) {
            this.selectTag = res.data
          }
        })
      } else {
        this.selectTag = val
      }
    },
    saveLog(val) {
      console.log(val)
      this.showTipsInfo = val
      this.showTips = true
      setTimeout(() => {
        this.showTips = false
      }, 3000)
    },
    jumpToTagHandle(step, workflowInfoId) {
      const index = this.tagList.findIndex((i) => i.actionId === this.selectTag?.actionId)
      if (this.tagList[index + step].actionCode === 'input') {
        getBriefByIdApi({ workflowInfoId }).then((res) => {
          if (res.data) {
            this.selectTag = {
              ...this.tagList[0],
              elementVOList: res.data.elementVOList
            }
          }
        })
      } else if (this.tagList[index + step].actionId?.length) {
        getActionByIdApi({
          actionId: this.tagList[index + step].actionId
        }).then((res) => {
          if (res.data) {
            this.selectTag = res.data
          }
        })
      } else {
        this.selectTag = this.tagList[index + step]
      }
    },
    cancelSelectTagHandle() {
      this.selectTag = null
    }
  }
})
